(function () {
  'use strict';

  var config = window.mgConsentConfig || {};
  var scripts = config.scripts || [];
  var cmp = config.cmp || 'complianz';
  var loaded = {};
  var jqueryQueue = [];
  var jqueryWatching = false;

  // GCM defaults are set in an inline <script> via wp_head priority 1
  // (consent_gcm_defaults in consent-loader.php) so they exist before any
  // enqueued script runs. We only need the gtag reference here for updates.
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  // ---------------------------------------------------------------------------
  // Script type handlers
  // ---------------------------------------------------------------------------

  function injectScript(service) {
    if (document.getElementById('cl-' + service.id)) {
      return;
    }
    var el = document.createElement('script');
    el.id = 'cl-' + service.id;
    el.async = true;
    el.src = service.src;
    document.head.appendChild(el);
  }

  function injectInline(service) {
    var el = document.createElement('script');
    el.id = 'cl-' + service.id;
    el.textContent = service.inline;
    document.head.appendChild(el);
  }

  function injectGtm(service) {
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var el = document.createElement('script');
    el.id = 'cl-' + service.id;
    el.async = true;
    el.src = 'https://www.googletagmanager.com/gtm.js?id=' + service.trackingId;
    document.head.appendChild(el);
  }

  function injectMetaPixel(service) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) {
        return;
      }
      n = f.fbq = function () {
        if (n.callMethod) {
          n.callMethod.apply(n, arguments);
        } else {
          n.queue.push(arguments);
        }
      };
      if (!f._fbq) {
        f._fbq = n;
      }
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('consent', 'grant');
    window.fbq('init', service.trackingId);
    window.fbq('track', 'PageView');
  }

  var handlers = {
    script: injectScript,
    inline: injectInline,
    gtm: injectGtm,
    pixel_meta: injectMetaPixel,
  };

  // ---------------------------------------------------------------------------
  // jQuery dependency queue
  // ---------------------------------------------------------------------------

  function flushJqueryQueue() {
    var queued = jqueryQueue.slice();
    jqueryQueue.length = 0;
    for (var i = 0; i < queued.length; i++) {
      loadService(queued[i]);
    }
  }

  function watchForJquery() {
    if (jqueryWatching) {
      return;
    }
    jqueryWatching = true;
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (typeof window.jQuery !== 'undefined') {
        clearInterval(interval);
        flushJqueryQueue();
      } else if (attempts >= 60) {
        clearInterval(interval);
      }
    }, 50);
  }

  // ---------------------------------------------------------------------------
  // Core loader
  // ---------------------------------------------------------------------------

  function loadService(service) {
    if (loaded[service.id]) {
      return;
    }

    if (service.requires_jquery && typeof window.jQuery === 'undefined') {
      jqueryQueue.push(service);
      watchForJquery();
      return;
    }

    var handler = handlers[service.type];
    if (handler) {
      loaded[service.id] = true;
      handler(service);
    }
  }

  function hasConsent(grantedCategories, category) {
    return grantedCategories.indexOf(category) !== -1;
  }

  function updateGoogleConsent(grantedCategories) {
    window.gtag('consent', 'update', {
      ad_storage: hasConsent(grantedCategories, 'marketing') ? 'granted' : 'denied',
      ad_user_data: hasConsent(grantedCategories, 'marketing') ? 'granted' : 'denied',
      ad_personalization: hasConsent(grantedCategories, 'marketing') ? 'granted' : 'denied',
      analytics_storage: hasConsent(grantedCategories, 'statistics') ? 'granted' : 'denied',
      functionality_storage: 'granted',
      personalization_storage: hasConsent(grantedCategories, 'preferences')
        ? 'granted'
        : 'denied',
      security_storage: 'granted',
    });
  }

  function processConsent(grantedCategories) {
    updateGoogleConsent(grantedCategories);

    for (var i = 0; i < scripts.length; i++) {
      var service = scripts[i];
      if (service.category === 'none' || hasConsent(grantedCategories, service.category)) {
        loadService(service);
      }
    }
  }

  function revokeAll() {
    updateGoogleConsent([]);

    if (typeof window.fbq === 'function') {
      window.fbq('consent', 'revoke');
    }
  }

  // ---------------------------------------------------------------------------
  // CMP adapters
  // ---------------------------------------------------------------------------

  var cmpAdapters = {
    complianz: {
      getGranted: function () {
        var categories = ['preferences', 'statistics', 'marketing'];
        if (typeof window.cmplz_has_consent !== 'function') {
          return [];
        }
        return categories.filter(function (cat) {
          return window.cmplz_has_consent(cat);
        });
      },
      listen: function () {
        document.addEventListener('cmplz_fire_categories', function (e) {
          var detail = e && e.detail;
          var categories =
            detail && Array.isArray(detail.categories) ? detail.categories : [];
          processConsent(categories);
        });
        document.addEventListener('cmplz_revoke', function () {
          revokeAll();
        });
      },
    },

    wpconsent: {
      getGranted: function () {
        if (typeof window.WPConsent === 'undefined' || typeof window.WPConsent.hasConsent !== 'function') {
          return [];
        }
        var categories = ['statistics', 'marketing'];
        return categories.filter(function (cat) {
          return window.WPConsent.hasConsent(cat);
        });
      },
      listen: function () {
        window.addEventListener('wpconsent_consent_saved', function (e) {
          var detail = e && e.detail ? e.detail : {};
          var granted = [];
          if (detail.statistics) {
            granted.push('statistics');
          }
          if (detail.marketing) {
            granted.push('marketing');
          }
          processConsent(granted);
        });
      },
    },

    none: {
      getGranted: function () {
        return ['functional', 'preferences', 'statistics', 'marketing'];
      },
      listen: function () {},
    },
  };

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------

  if (!scripts.length) {
    return;
  }

  var adapter = cmpAdapters[cmp] || cmpAdapters.complianz;

  // Bind CMP events for future consent changes.
  adapter.listen();

  // Rehydrate for returning visitors who already have consent.
  processConsent(adapter.getGranted());
})();
